const gngSequence = [
    'Frozen', 'Hard', 'Firm', 'Fast', 'Good To Firm', 'Standard To Fast', 'Good', 'Standard',
    'Good To Yielding', 'Good To Soft', 'Standard To Slow', 'Yielding', 'Yielding To Soft',
    'Muddy', 'Soft', 'Slow', 'Sloppy', 'Very Soft', 'Soft To Heavy', 'Heavy',
];

const gngCodeSequence = [
    'FZ', 'HD', 'F', 'FT', 'GF', 'SF', 'G', 'SD', 'GY', 'GS',
    'SS', 'Y', 'YS', 'MY', 'S', 'SW', 'SY', 'VS', 'SH', 'HY',
];

export const goingSortFn = (a, b) =>
    gngSequence.indexOf(a.going) - gngSequence.indexOf(b.going);

export const goingCodeSortFn = (a, b) =>
    gngCodeSequence.indexOf(a.goingTypeCode) - gngCodeSequence.indexOf(b.goingTypeCode);




// WEBPACK FOOTER //
// ./src/js/utils/going.js